import update from 'immutability-helper'
import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {makeStyles} from 'external/material'

import useForm from '../../../helpers/form-hook'
import useValidations from '../../../helpers/validations-hook'
import create from '../../../helpers/command'

import Dialog from '../../responsive-fullscreen-dialog'
import TextInput from '../../text-input'
import {requiredTextAfterAttempt} from '../../../helpers/validations'

const validations = {
  title: [requiredTextAfterAttempt('title', 'required-title')],
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  duplicateTitleInput: {
    paddingTop: 10
  }
}))

export default function DuplicateAssessmentForm ({context, onDuplicate}) {

  const {translate, quizDialogs, quizAssessmentToDuplicate: assessment} = context

  const isOpen = quizDialogs['duplicate-assessment']

  const classes = useStyles()
  const {state, setState, handleChange, resetState} = useForm({attempted: false, title: assessment.title})
  const {errors, errorCount, validate, resetErrors} = useValidations(validations)

  const createStateHandler = mapState => (event) => {
    const value = event.target.value == '' ? undefined : event.target.value
    setState({...state, ...mapState(value)})
  }

  function closeDialog () {
    const quizDialogs = update(context.quizDialogs, {'duplicate-assessment': {$set: false}})
    context.setState({quizDialogs})
    resetState()
  }

  async function handleDuplicate() {
    if (validate({...state, attempted: true})) {
      const [duplicatedId] = await create('quiz', 'duplicateAssessment')({id: assessment.id, title: state.title})
      closeDialog()
      if (onDuplicate) onDuplicate()
    } else {
      setState({...state, attempted: true})
    }
  }

  React.useEffect(() => { validate(state) }, [state])
  React.useEffect(() => { 
    setState({...state, title: assessment.title})
  }, [assessment])

  return (
      <Dialog
        open={isOpen}
        close={closeDialog}
        title={translate('duplicate-assessment-message', assessment)}
        confirm={<Button variant="contained" color="primary" onClick={handleDuplicate}>{translate('duplicate')}</Button>}
        cancel={<Button variant="contained" color="secondary" onClick={closeDialog}>{translate('cancel')}</Button>}
      >
       <Box className={classes.duplicateTitleInput}>
         <TextInput
           controlFullWidth
           controlVariant="outlined"
           id="title"
           inputAutoComplete="title"
           caption={translate('title')}
           value={state.title}
           inputOnChange={handleChange('title')}
           controlError={errors.title.length > 0}
           errorMessage={errors.title.length > 0 ? translate(errors.title) : undefined}
         />
        </Box>
      </Dialog>
  )
}
